export enum LegalPersonVerificationMethod {
    corporate_number_verification = 'corporate number verification',
    legal_person_verification = 'legal person verification',
}

export enum Status {
    verified = 'verified',
    not_verified = 'not_verified',
}

export enum VerificationType {
    document_verification = 'document verification',
    personal_verification = 'personal verification',
    legal_person_verification = 'legal person verification',
    db_verification = 'db verification',
}

export enum LegalPersonVerificationResult {
    approved = 'approved',
    denied = 'denied',
}

export interface LegalPersonVerificationItem {
    corporateName: string;
    corporateNumber: number;
    receivedDate: string;
    legalPersonVerificationMethod: LegalPersonVerificationMethod;
    status: Status;
}
